import {loadable} from "jotai/utils";
import {User} from "../types/domain/user";
import {getUsers} from "../services/userService";
import {atomWithRefresh} from "../utils/jotaiUtils";

/**
 * All users
 */
export const usersAtom = atomWithRefresh<Promise<User[]>>(async () => await getUsers());

usersAtom.debugLabel = "users";
export const usersLoadable = loadable(usersAtom);
